import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateQuestionList } from "../../features/aiControl/aiControlSlice"

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 10px);
    padding: 20px;
    color: ${({theme}) => theme.mainTextColor};
    font-size: var(--font-size-sm);
    margin-bottom: 40px;
    margin: 5px;
    border-bottom: ${({theme, isItLast}) => !isItLast && `4px solid ${theme.mainBorderColor}`};

    .top{
        width: 100%;
        margin-bottom: 5px;

        .question-number{
            color: var(--color-main);
            font-weight: var(--font-weight-lg);
        }
    }

    .textarea-list{
        display: flex;
        flex-direction: column;
        gap: 10px;

        textarea{
            border: 2px solid ${({theme}) => theme.mainBorderColor};
            padding: 10px;
            font-size: var(--font-size-sm);
            border-radius: 10px;
            height: auto;
            min-height:100px;
            max-height: 260px;
            resize: vertical;
            font-variant-numeric: lining-nums;

            &::placeholder{
                font-weight: var(--font-weight-lg);
                color: ${({theme}) => theme.mainTextColor};
            }
        }
    }

    .bottom-content-wrapper{
        display: flex;
        align-items: center;
        margin-top: 10px;

        .activity-container{
            width: 100px;
            border: 2px solid ${({theme}) => theme.mainBorderColor};
            border-radius: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px;
            cursor: pointer;
            margin-right: 10px;


            .activity-top{
                width: 12px;
                height: 12px;
                border-radius: 50%;
            }

            .active{
                background-color: var(--color-green);
            }

            .passive{
                background-color: var(--color-main);
            }
        }

        .vurgu-desc{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
        }

}
`

//! bu eklerken kullanılan
const AIQuestionItemAdd = ({item, order, isItLast}) => {

    const dispatch = useDispatch()

  return (
    <Container isItLast={isItLast}> 
        <div className="top">
            <span className="question-number">{order} Soru</span>
        </div>
        <div className="textarea-list">
            <textarea value={item.question} placeholder={`Soru ${order}`} onChange={(e) => dispatch(updateQuestionList({...item, question: e.target.value}))}></textarea>
            <textarea value={item.answer} placeholder={`Cevap ${order}`} onChange={(e) => dispatch(updateQuestionList({...item, answer: e.target.value}))}></textarea>
        </div>
        <div className="bottom-content-wrapper">
            <div className="activity-container" onClick={() => dispatch(updateQuestionList({id: item.id, isActive: !item.isActive}))}>
                <span>{item.isActive ? "Aktif" : "Pasif"}</span>
                <span className={item.isActive ? "activity-top active": "activity-top passive"}/>
            </div>
            <p className="vurgu-desc">Vurgulamak istediğiniz kısmın başına ve sonuna *(yıldız karakteri) koyabilirsiniz.</p>
        </div>
    </Container>
  )
}

export default AIQuestionItemAdd